import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Loading from './Loading';

class FlyoutLoading extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      loadingMessage: null,
    };

    this.timer = null;
    this.timerSetTimestamp = Date.now();
  }

  componentDidUpdate(prevProps) {
    const {
      waitBeforeShowTimeMs,
      minimumShowtimeMs,
      show,
    } = this.props;
    const isShowing = this.state.show;

    if (show && (!prevProps.show || !isShowing)) {
      // When shown, set a timer in the future to make the show effective
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.show();
      }, waitBeforeShowTimeMs);

      this.timerSetTimestamp = Date.now();
    } else if (!show && !!prevProps.show) {
      // Hide the thing, but stay up for at least the specified minimum time
      clearTimeout(this.timer);
      const elapsedTime = Date.now() - this.timerSetTimestamp;
      const remainingTime = Math.max(0, minimumShowtimeMs - elapsedTime);

      if (remainingTime > 0) {
        this.timer = setTimeout(() => {
          this.hide();
        }, remainingTime);
      } else {
        this.hide();
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  setShown(visible) {
    const { onShowStateChanged, loadingMessage } = this.props;
    this.setState({
      show: visible,
      // Latch the loading message into state whenever we're shown.
      // If you rely on the prop alone, then you can see the loading message
      // go away as your component may remove it while the minimumShowtimeMs
      // hasn't yet been met
      loadingMessage,
    });
    if (_.isFunction(onShowStateChanged)) {
      onShowStateChanged(visible);
    }
  }

  show() {
    this.setShown(true);
  }

  hide() {
    this.setShown(false);
  }

  render() {
    const { show, loadingMessage } = this.state;

    return (
      <div className={`flyout-loading ${show ? 'flyout-loading-visible' : ''}`}>
        { show && <div className='loading-wrapper'><Loading className='foooo' width='100' height='100' /></div> }
        { show && loadingMessage && <span className='loading-message'>{loadingMessage}</span> }
      </div>);
  }
}

FlyoutLoading.propTypes = {
  show: PropTypes.bool,
  loadingMessage: PropTypes.string,
  waitBeforeShowTimeMs: PropTypes.number,
  minimumShowtimeMs: PropTypes.number,
  onShowStateChanged: PropTypes.func,
};

FlyoutLoading.defaultProps = {
  show: false,
  loadingMessage: null,
  waitBeforeShowTimeMs: 150,
  minimumShowtimeMs: 800,
  onShowStateChanged: () => {},
};

export default FlyoutLoading;



// WEBPACK FOOTER //
// ./src/views/Components/FlyoutLoading.js